import * as React from "react";
function SvgPinPlus(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        d="M18.71 14.25a2 2 0 001.69.3l3.46-1.09L20 10.83l-6.19-4.2L9.94 4l.26 3.62a2 2 0 00.91 1.46l.71.48-4.49 6.61-2.72.73 9.23 6.27-.32-2.8 4.48-6.6zM9.67 19.38L4.14 28M18.51 23.13h9.35M23.19 18.45v9.36"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2.67}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgPinPlus);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
